import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { get } from 'lodash'
import T from 'T'
import StopListItem from 'components/route-manager/BulkActions/common/StopListItem/StopListItem'
import StopPositionLabel from 'components/route-manager/BulkActions/common/StopListItem/StopPositionLabel'
import StopPositionField from 'components/route-manager/BulkActions/common/StopListItem/StopPositionField'
import { INPUT_WIDTH } from 'components/route-manager/BulkActions/BulkAssignStopsDialog/settings'
import { stopStatus } from 'utils/workOrderStatus'

const RenderStopListItem = props => {
  const { row } = props

  const formContext = useFormContext()
  const control = formContext?.control
  const errors = formContext?.formState?.errors

  const watch = formContext?.watch
  const position = (row?.position ?? 0) + 1
  const toBeInserted = row?.toBeInserted ?? false
  const workOrderStatus = stopStatus(row)

  const onSequenceChange = row?.onSequenceChange
  const isLegacyMode = !onSequenceChange
  const selectedRoute = isLegacyMode ? watch?.('selectedRoute') : null
  const isRouteSelected = isLegacyMode ? Boolean(selectedRoute) : row?.isRouteSelected ?? false

  const handleFocus = event => {
    event.target.select()
  }

  const handleCellClick = event => {
    event.stopPropagation()
  }

  const avatarContent = toBeInserted ? (
    <>
      {isLegacyMode ? (
        <StopPositionField
          disabled={!isRouteSelected}
          required
          error={Boolean(get(errors, 'sequence.message'))}
          rules={{ required: T.REQUIRED_HELPER_TEXT }}
          control={control}
          name="sequence"
          size="small"
          allowNegative={false}
          thousandSeparator={false}
          decimalScale={0}
          InputProps={{ onClick: handleCellClick, onFocus: handleFocus }}
        />
      ) : (
        <TextField
          disabled={!isRouteSelected}
          required
          value={position}
          onChange={e => onSequenceChange?.(e.target.value)}
          onFocus={handleFocus}
          sx={{
            width: INPUT_WIDTH,
            mr: 1,
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 },
            '& input[type=number]': { MozAppearance: 'textfield' },
          }}
          size="small"
          type="number"
          inputProps={{ min: 1, style: { textAlign: 'center' } }}
        />
      )}
    </>
  ) : (
    <StopPositionLabel position={position} workOrderStatus={workOrderStatus} />
  )

  return <StopListItem row={row} AvatarContent={avatarContent} />
}

RenderStopListItem.propTypes = {
  row: PropTypes.object,
}

export default RenderStopListItem
